var Popup = function(_option) {
    this.option = {
        overlayTemplate: require('../template/overlay.html')
    };
    $.extend(this.option, _option);
    require('TweenMax');
    this.container = $('#js-pjax');
};

Popup.prototype = {
    init: function() {
        var _self = this;
        $('#js-overlay').remove();
        $('body').append(_self.option.overlayTemplate);
        _self.overlay = $('#js-overlay');
        _self.overlayContent = $('#js-overlayContent');
        _self.loading = $('#js-overlayLoading');
        _self.overlay.css({
            transform: 'scale(0, 0)'
        });
        //_self.overlay.on('click', function() {
        //    _self.close();
        //});
        _self.closeBtn = $('#js-overlayClose');
        _self.closeBtn.on('click', function() {
            _self.close();
        });
    },
    open: function(index) {
        var _self = this;

        _self.activeIndex = index;
        _self.overlay.css({
            transform: 'scale(1, 1)'
        });
        TweenMax.to(_self.overlay, 0.2, {
            autoAlpha: 1,
            //transform: 'scale(1, 1)',
            ease: Power1.easeInOut,
            onComplete: function() {
                //スクロールを止める
                //_self.currentScrollY = $(window).scrollTop();
                //_self.container.css({
                //    position: 'fixed',
                //    width: window.innerWidth,
                //    top: -1 * _self.currentScrollY,
                //    height: window.innerHeight-40
                //});
                //$('html').css({
                //    overflow: 'hidden'
                //});
                _self.go(_self.activeIndex);
            }
        });
    },
    close: function() {
        var _self = this;

        TweenMax.to(_self.overlay, 0.6, {
            autoAlpha: 0,
            ease: Power1.easeInOut,
            onComplete: function(){
                _self.overlayContent.empty();
                _self.overlay.css({
                    transform: 'scale(0, 0)'
                });
            }
        });
        //画面を戻す
        //_self.container.css({
        //    position: 'relative',
        //    width: 'auto',
        //    top: 0,
        //    height: 'auto'
        //});
        //$('html').css({
        //    overflow: 'visible'
        //});
        //$('html, body').prop({scrollTop: _self.currentScrollY});
    },
    go: function(target) {
        var _self = this;
        //data-popupのidを探してappend
        _self.overlayContent.find('.popup-close').off('click.popupclose');
        _self.overlayContent.empty();
        var contents = document.getElementById(target).outerHTML;
        //console.log(contents);
        _self.overlayContent.append(contents);
        _self.overlayContent.find('.popup-close').on('click.popupclose', function() {
            _self.close();
        });
    },
    showLoading: function() {
        var _self = this;
        _self.loading.addClass('is-loading');
    },
    hideLoading: function() {
        var _self = this;
        _self.loading.removeClass('is-loading');
    }
};

module.exports = Popup;


/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/pc/assets/js/module/Popup.js
 **/